<template>
    <div class="filter-entry">
        <div class="filter-label">
            {{ name }}
        </div>
        <div style="margin-left: 20px;">
            <el-checkbox-group v-model="value" @change="storeValue">
                <el-checkbox label="under">Underpacing</el-checkbox>
                <el-checkbox label="onpace">On Pace</el-checkbox>
                <el-checkbox label="over">Overpacing</el-checkbox>
                <el-checkbox label="filled">Fulfilled (over 100%)</el-checkbox>
            </el-checkbox-group>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'name',
            'id',
            'data'
        ],
        data() {
            return {
                value: []
            };
        },
        watch: {
            data: {
                deep: true,
                handler() {
                    if (this.data[this.id] && Array.isArray(this.data[this.id])) {
                        this.value = this.data[this.id];
                    }
                }
            }
        },
        methods: {
            storeValue() {
                this.data[this.id] = this.value;
            }
        }
    }
</script>